export const defaultFont = "proxima-nova, sans-serif";

export const keypad = {
  height: "4.1em"
};

export const footer = {
  height: "1em"
};

export const keypadWrapper = {
  height: `calc(${keypad.height} + ${footer.height})`
};
